module.exports = __webpack_public_path__ + "banquet/components/images/checkmark_large.c37dc122445e75941dc39602b46ad645.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/checkmark_large.svg
// module id = 1699
// module chunks = 1